<template>
    <div class="relative">
        <prime-vue-progress-bar :pt="pt" :value="value">
            <slot v-if="hasTemplate && value >= 3" />
            <span v-else />
        </prime-vue-progress-bar>
        <span
            v-if="value <= 3 && hasTemplate"
            class="absolute left-0 top-1/2 ml-1.5 -translate-y-1/2 text-xs font-semibold text-white"
        >
            {{ Math.floor(value) }}%
        </span>
    </div>
</template>

<script setup lang="ts">
import {computed, type ComputedRef, defineProps, type Slots, useSlots} from 'vue';
import PrimeVueProgressBar from 'primevue/progressbar';
import type {ProgressBarPassThroughOptions} from 'primevue/progressbar';

type Props = {
    value: number;
    isHeat?: boolean;
};

const props = defineProps<Props>();
const slots: Slots = useSlots();
const hasTemplate: ComputedRef<boolean> = computed((): boolean => !!slots.default);

const level = computed(() => Math.min(Math.ceil(props.value / 10) * 10, 100));

const fillClass = computed(() => (props.isHeat ? `bg-heat-${level.value}` : 'bg-surface-200'));

const pt = computed<ProgressBarPassThroughOptions>(() => ({
    root: () => ({
        class: [
            'relative',
            'overflow-hidden',
            'rounded-md',
            props.isHeat && 'bg-surface-200',
            props.isHeat ? `h-[20px]` : 'h-4',
        ],
    }),
    value: () => ({
        class: [fillClass.value, 'justify-center'],
    }),
}));
</script>
